import { Modal } from "@pacificoseguros/pixie/react/modal";
import React, { memo } from "react";
import iconGenericError from "../../assets/icons/ic-generic-error.svg";
import { Column } from "../../components/layout/flex-layout";
import { SizedBox } from "../../components/layout/sized-box";
import { SpacingBox } from "../../components/layout/spacing-box";
import { Typography } from "../../components/typography/typography";
import { DatalayerModal } from "../../libs/datalayer/components/datalayer-modal";
import { DatalayerModalPixieButton } from "../../libs/datalayer/components/datalayer-modal-pixie-button";
import { useGenericErrorModal } from "./hooks/use-generic-error-modal";

const GenericErrorModal = () => {
    const { opened, close } = useGenericErrorModal();
    return (
        opened && (
            <DatalayerModal
                open={opened}
                onClose={close}
                as={Modal}
                type="Error"
                name="Genérico"
            >
                <SpacingBox pt={30} pb={10}>
                    <Typography textAlign="center" as="div" fontSize={16}>
                        <SizedBox width={280}>
                            <Column align="center">
                                <img
                                    src={iconGenericError}
                                    alt="error generico"
                                />
                            </Column>
                            <SpacingBox mb={27} />
                            <Typography fontSize={20}>
                                <b>
                                    ¡Ooops!<br></br>Tuvimos un error
                                </b>
                            </Typography>
                            <SpacingBox mb={17} />
                            <div>
                                Parece que por el momento estamos<br></br>
                                teniendo algunos problemas. Por<br></br>
                                favor vuelve a intentar o, si deseas,
                                <br></br>llámanos para ayudarte.
                            </div>
                            <SpacingBox mb={26} />
                            <a href="tel:015135000">
                                <Typography
                                    variant="secondary"
                                    decoration="underline"
                                    fontSize={24}
                                >
                                    01 513 5000
                                </Typography>
                            </a>
                            <SpacingBox mb={26} />
                            <DatalayerModalPixieButton
                                kind="secondary"
                                inverse
                                fluid
                                onClick={close}
                                label="Volver"
                            >
                                Volver
                            </DatalayerModalPixieButton>
                        </SizedBox>
                    </Typography>
                </SpacingBox>
            </DatalayerModal>
        )
    );
};

export default memo(GenericErrorModal);
